const config = {
    host: process.env.NODE_ENV === 'production' ? 'http://sfl.fengone.com' : 'http://sfl.fengone.com'
}

export default config